import { render, staticRenderFns } from "./classify_tag.vue?vue&type=template&id=5fcc7d5b"
import script from "./classify_tag.vue?vue&type=script&lang=js"
export * from "./classify_tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports